import React from "react";
export var footerBasicType = "basic";
export var footerLegalTextType = "legalText";
export var FooterContext = React.createContext(footerLegalTextType);